import {Enum} from 'enumify';

export default class PaymentStatus extends Enum {}

PaymentStatus.initEnum({
  PAID: {
    statusName: 'PAID',
  },
  BATCH_PAID: {
    statusName: 'BATCH_PAID',
  },
  MANUAL_PAID: {
    statusName: 'MANUAL_PAID',
  },
  STRIPE_PAID: {
    statusName: 'STRIPE_PAID',
  },
  FAILED: {
    statusName: 'FAILED',
  },
  REFUNDED: {
    statusName: 'REFUNDED',
  },
  SCHEDULED: {
    statusName: 'SCHEDULED',
  }
});



// WEBPACK FOOTER //
// ./src/constants/PaymentStatus.js